// extracted by extract-css-chunks-webpack-plugin
module.exports = {"TabNav":"TabNav_2fcwM_v13-0-0","TabNav_Items":"TabNav_Items_1fV0a_v13-0-0","TabNav_Aux":"TabNav_Aux_1Bccp_v13-0-0"};
    if(module.hot) {
      // 1588357788402
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  